import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { scbProducts } from '../../data/products';
import { ProductCard } from '../products/ProductCard';
import { useTranslation } from '../../lib/i18n';
interface ProductShowcaseProps {
  onRequestQuote: (productId: string) => void;
}
export function ProductShowcase({
  onRequestQuote
}: ProductShowcaseProps) {
  const {
    t
  } = useTranslation();
  return <section id="products" className="py-12 md:py-20 bg-dark-bg" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-8 md:mb-12" data-id="element-215">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 md:mb-4" data-id="element-216">
            {t.showcase.title}{' '}
            <span className="text-brand-yellow" data-id="element-217">
              {t.showcase.titleHighlight}
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-218">
            {t.showcase.subtitle}
          </p>
        </div>
        <div className="space-y-6 md:space-y-10" data-id="element-219">
          {scbProducts.map(product => <ProductCard key={product.id} product={product} layout="horizontal" onRequestQuote={onRequestQuote} data-id="element-220" />)}
        </div>
        <div className="mt-10 text-center" data-id="element-221">
          <Link to="/products" className="inline-flex items-center gap-2 text-brand-yellow hover:text-white transition-colors font-semibold text-sm border border-brand-yellow/30 hover:border-brand-yellow/60 rounded-lg px-5 py-3" data-id="element-222">
            Pogledajte sve modele uključujući SC-A i SC-C
            <ArrowRightIcon className="w-4 h-4" data-id="element-223" />
          </Link>
        </div>
      </div>
    </section>;
}